export default () => ({
    url: process.env.REACT_APP_API_ENDPOINT || "https://devapi.flightlocal.com/graphql",
    subscriptionUrl: process.env.REACT_APP_SUBSCRIPTION_ENDPOINT || "wss://devapi.flightlocal.com/graphql",
    uploadUrl: process.env.REACT_APP_UPLOAD_API_ENDPOINT || "https://devupload.flightlocal.com/upload",
    publicUploadUrl: process.env.REACT_APP_UPLOAD_PUBLIC_API_ENDPOINT || "https://devupload.flightlocal.com/public-upload",
})